const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const normalizeValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const exportRowsToCSV = ({ rows, columns, fileName = 'table-export.csv' }) => {
  const header = columns.map((column) => column.label);
  const dataRows = rows.map((row) =>
    columns.map((column) => {
      const raw = normalizeValue(column.accessor(row));
      return `"${raw.replace(/"/g, '""')}"`;
    })
  );

  const csv = [header.join(','), ...dataRows.map((entry) => entry.join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, fileName.endsWith('.csv') ? fileName : `${fileName}.csv`);
};

export const exportRowsToExcel = ({ rows, columns, fileName = 'table-export.xls' }) => {
  const headerHtml = columns.map((column) => `<th>${column.label}</th>`).join('');
  const bodyHtml = rows
    .map((row) => {
      const tds = columns
        .map((column) => `<td>${normalizeValue(column.accessor(row))}</td>`)
        .join('');
      return `<tr>${tds}</tr>`;
    })
    .join('');

  const html = `
    <html>
      <head><meta charset="UTF-8" /></head>
      <body>
        <table border="1">
          <thead><tr>${headerHtml}</tr></thead>
          <tbody>${bodyHtml}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  downloadBlob(blob, fileName.endsWith('.xls') ? fileName : `${fileName}.xls`);
};

export const exportRowsToPdfPrint = ({ rows, columns, title = 'Table Export' }) => {
  const headerHtml = columns.map((column) => `<th>${column.label}</th>`).join('');
  const bodyHtml = rows
    .map((row) => {
      const tds = columns
        .map((column) => `<td>${normalizeValue(column.accessor(row))}</td>`)
        .join('');
      return `<tr>${tds}</tr>`;
    })
    .join('');

  const win = window.open('', '_blank');
  if (!win) return;
  win.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 16px; }
          h2 { margin: 0 0 12px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #ddd; padding: 8px; font-size: 12px; text-align: left; }
          th { background: #f5f5f5; }
        </style>
      </head>
      <body>
        <h2>${title}</h2>
        <table>
          <thead><tr>${headerHtml}</tr></thead>
          <tbody>${bodyHtml}</tbody>
        </table>
      </body>
    </html>
  `);
  win.document.close();
  win.focus();
  win.print();
};

